import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorParamList,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { DayFilter } from "./filter";

type ParamList = {
  TeamScheduleAdminMain: UserLoggedInNavigatorParamList["TeamScheduleAdmin"];
  TeamScheduleAdminArchived: {
    teamId: string;
  };
  TeamScheduleAdminTemplates: {
    teamId: string;
    selectedDaysFilter: DayFilter;
    freq: "daily" | "weekly" | "monthly";
  };
};

export type TeamScheduleAdminNavigationProp<T extends keyof ParamList> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"TeamScheduleAdmin">,
    NativeStackNavigationProp<ParamList, T>
  >;

export type TeamScheduleAdminScreenProps<T extends keyof ParamList> = {
  navigation: TeamScheduleAdminNavigationProp<T>;
  route: RouteProp<ParamList, T>;
};

export const TeamScheduleAdminStack = createNativeStackNavigator<ParamList>();
